import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

export function useActiveSale() {
  const [sale, setSale] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchActiveSale = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('get-active-sale');

        if (error) throw error;

        if (data?.active && data?.sale) {
          setSale(data.sale);
        } else {
          setSale(null);
        }
      } catch (err) {
        console.error('Error fetching active sale:', err);
        setError(err.message);
        setSale(null);
      } finally {
        setLoading(false);
      }
    };

    fetchActiveSale();

    // Refresh every 5 minutes to catch sale transitions
    const interval = setInterval(fetchActiveSale, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return { sale, loading, error };
}
